module.exports = __webpack_public_path__ + "img/gh.4f42428a.svg";